// Indian Holidays and Important Events for 2026
export const indianHolidays2026 = [
  {
    date: '2026-01-01',
    name: 'New Year\'s Day',
    type: 'public',
    category: 'National',
    emoji: '🎉'
  },
  {
    date: '2026-01-14',
    name: 'Makar Sankranti',
    type: 'festival',
    category: 'Hindu',
    emoji: '🪁'
  },
  {
    date: '2026-01-15',
    name: 'Pongal',
    type: 'festival',
    category: 'Hindu',
    emoji: '🌾'
  },
  {
    date: '2026-01-26',
    name: 'Republic Day',
    type: 'public',
    category: 'National',
    emoji: '🇮🇳',
    description: 'Celebrating the Constitution of India'
  },
  {
    date: '2026-02-19',
    name: 'Chhatrapati Shivaji Maharaj Jayanti',
    type: 'observance',
    category: 'Regional',
    emoji: '⚔️'
  },
  {
    date: '2026-03-03',
    name: 'Maha Shivaratri',
    type: 'festival',
    category: 'Hindu',
    emoji: '🕉️'
  },
  {
    date: '2026-03-14',
    name: 'Holi',
    type: 'public',
    category: 'Hindu',
    emoji: '🎨',
    description: 'Festival of Colors'
  },
  {
    date: '2026-03-30',
    name: 'Ugadi',
    type: 'festival',
    category: 'Hindu',
    emoji: '🌸'
  },
  {
    date: '2026-03-30',
    name: 'Gudi Padwa',
    type: 'festival',
    category: 'Hindu',
    emoji: '🚩'
  },
  {
    date: '2026-04-02',
    name: 'Ram Navami',
    type: 'festival',
    category: 'Hindu',
    emoji: '🏹'
  },
  {
    date: '2026-04-02',
    name: 'Good Friday',
    type: 'public',
    category: 'Christian',
    emoji: '✝️'
  },
  {
    date: '2026-04-04',
    name: 'Easter Sunday',
    type: 'observance',
    category: 'Christian',
    emoji: '🐣'
  },
  {
    date: '2026-04-06',
    name: 'Mahavir Jayanti',
    type: 'public',
    category: 'Jain',
    emoji: '☸️'
  },
  {
    date: '2026-04-14',
    name: 'Ambedkar Jayanti',
    type: 'public',
    category: 'National',
    emoji: '📖'
  },
  {
    date: '2026-05-01',
    name: 'May Day / Labour Day',
    type: 'public',
    category: 'National',
    emoji: '⚙️'
  },
  {
    date: '2026-05-26',
    name: 'Buddha Purnima',
    type: 'public',
    category: 'Buddhist',
    emoji: '☸️'
  },
  {
    date: '2026-07-07',
    name: 'Rath Yatra',
    type: 'festival',
    category: 'Hindu',
    emoji: '🛕'
  },
  {
    date: '2026-08-04',
    name: 'Eid al-Adha (Bakrid)',
    type: 'public',
    category: 'Muslim',
    emoji: '🕌',
    description: 'Festival of Sacrifice'
  },
  {
    date: '2026-08-15',
    name: 'Independence Day',
    type: 'public',
    category: 'National',
    emoji: '🇮🇳',
    description: 'India\'s Independence from British Rule'
  },
  {
    date: '2026-08-19',
    name: 'Raksha Bandhan',
    type: 'festival',
    category: 'Hindu',
    emoji: '🎁'
  },
  {
    date: '2026-08-26',
    name: 'Janmashtami',
    type: 'public',
    category: 'Hindu',
    emoji: '🦚',
    description: 'Birth of Lord Krishna'
  },
  {
    date: '2026-09-02',
    name: 'Ganesh Chaturthi',
    type: 'public',
    category: 'Hindu',
    emoji: '🐘'
  },
  {
    date: '2026-09-16',
    name: 'Onam',
    type: 'festival',
    category: 'Hindu',
    emoji: '🌺'
  },
  {
    date: '2026-10-02',
    name: 'Gandhi Jayanti',
    type: 'public',
    category: 'National',
    emoji: '🕊️',
    description: 'Birth Anniversary of Mahatma Gandhi'
  },
  {
    date: '2026-10-08',
    name: 'Durga Puja Begins',
    type: 'festival',
    category: 'Hindu',
    emoji: '🗡️'
  },
  {
    date: '2026-10-12',
    name: 'Dussehra',
    type: 'public',
    category: 'Hindu',
    emoji: '🏹',
    description: 'Victory of Good over Evil'
  },
  {
    date: '2026-10-20',
    name: 'Karva Chauth',
    type: 'observance',
    category: 'Hindu',
    emoji: '🌙'
  },
  {
    date: '2026-10-29',
    name: 'Dhanteras',
    type: 'festival',
    category: 'Hindu',
    emoji: '💰'
  },
  {
    date: '2026-10-31',
    name: 'Diwali / Deepavali',
    type: 'public',
    category: 'Hindu',
    emoji: '🪔',
    description: 'Festival of Lights'
  },
  {
    date: '2026-11-01',
    name: 'Govardhan Puja',
    type: 'festival',
    category: 'Hindu',
    emoji: '⛰️'
  },
  {
    date: '2026-11-02',
    name: 'Bhai Dooj',
    type: 'festival',
    category: 'Hindu',
    emoji: '👫'
  },
  {
    date: '2026-11-25',
    name: 'Guru Nanak Jayanti',
    type: 'public',
    category: 'Sikh',
    emoji: '🙏'
  },
  {
    date: '2026-12-25',
    name: 'Christmas',
    type: 'public',
    category: 'Christian',
    emoji: '🎄',
    description: 'Birth of Jesus Christ'
  }
];

// Helper function to get holidays for a specific date
export const getHolidaysForDate = (dateStr) => {
  return indianHolidays2026.filter(holiday => holiday.date === dateStr);
};

// Helper function to check if a date is a holiday
export const isHoliday = (dateStr) => {
  return indianHolidays2026.some(holiday => holiday.date === dateStr);
};

// Helper function to get all public holidays
export const getPublicHolidays = () => {
  return indianHolidays2026.filter(holiday => holiday.type === 'public');
};

// Helper function to format date to YYYY-MM-DD
export const formatDateForHoliday = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
